export default "__VITE_ASSET__gP1aSrSu__"